import React from 'react';
import styles from './AIGeneratedBadge.module.scss';
import MagicUploadIcon from '../../assets/Svg/MagicuploadIcon';

interface AIGeneratedBadgeProps {
    className?: string;
}

const AIGeneratedBadge: React.FC<AIGeneratedBadgeProps> = ({ className }) => {
    return (
        <span className={`${styles.aiGenerated} ${className || ''}`}>
            <MagicUploadIcon colour="var(--label-color)" width="16" height="15" />
            <span className={styles.aiGeneratedText}>AI generated</span>
        </span>
    );
};

export default AIGeneratedBadge;
